var exports = {
  "Qs": "xfb577c5e--5ca570--content",
  "DD": "xfb577c5e--5ca570--title",
  "VA": "xfb577c5e--5ca570--subtitle",
  "NQ": "xfb577c5e--5ca570--features-list",
  "N4": "xfb577c5e--5ca570--feature",
  "h_": "xfb577c5e--5ca570--description",
  "e4": "xfb577c5e--5ca570--banks",
  "NS": "xfb577c5e--5ca570--author-description",
  "VZ": "xfb577c5e--5ca570--banks-list",
  "pK": "xfb577c5e--5ca570--bank-item",
  "T6": "xfb577c5e--5ca570--banks-title",
};

module.exports = exports;
